import { en } from './en'
import { fr } from './fr'

export const employeeOpportunityPage = {
  en,
  fr
}
